import * as mod from 'react';
if (false) {
  module.exports = mod.default;
} else {
  module.exports = mod;
}